import type { JobDayStatus } from '@/api/tracking.api';
import type { MapPinData } from '@/components/tracking/MapaTracking';

/**
 * Metadatos visuales del estado semántico de un trabajo del día (mapa/lista):
 * etiqueta en español llano, tono del pin en el mapa y variante del badge.
 * PURO y testeable (entorno node, sin DOM).
 */
export interface JobDayStatusMeta {
  label: string;
  tone: NonNullable<MapPinData['tone']>;
  badge: 'default' | 'brand' | 'success' | 'warning' | 'danger' | 'info';
}

export const JOB_DAY_STATUS_META: Record<JobDayStatus, JobDayStatusMeta> = {
  en_camino: { label: 'En camino', tone: 'info', badge: 'info' },
  llego: { label: 'En sitio', tone: 'ok', badge: 'success' },
  vencido: { label: 'Vencido (sin salida)', tone: 'warn', badge: 'danger' },
  completado: { label: 'Completado', tone: 'muted', badge: 'default' },
  no_completado: { label: 'No completado', tone: 'amber', badge: 'warning' },
  cancelado: { label: 'Cancelado', tone: 'muted', badge: 'default' },
};

/** "3:30 PM" local desde un ISO, o null si el trabajo no tiene cita. */
export function scheduledHourLabel(iso: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleTimeString('es-DO', { hour: 'numeric', minute: '2-digit' });
}
